import React, { useState, useContext } from "react";
import StoreContext from "../../shared/сontext/StoreContext";
import BahtIcon from "../../../assets/svg/icons/baht.inline.svg";
import UpdateIcon from "../../../assets/svg/icons/update.inline.svg";

const FreespinBalance = () => {
  const [balanceLoading, setBalanceLoading] = useState(false);

  const context = useContext(StoreContext);
  const { balanceFree, balanceUpdateFunc } = context;

  const updateBalance = () => {
    setBalanceLoading(true);
    balanceUpdateFunc(setBalanceLoading);
  }

  return (
    <div className="user-balance">
      <span className="balance-name">ยอดคงเหลือเกม</span>
      <button type="button" className={balanceLoading ? "update loading" : "update"} aria-label={"Update"}
              onClick={() => updateBalance()}>
        <UpdateIcon/>
      </button>
      <span className="baht-icon">
        <BahtIcon />
      </span>
      <div className="coin-balance">{balanceFree}</div>
    </div>
  )
};

export default FreespinBalance;
